import useTranslation from 'next-translate/useTranslation';
import OrderByProvidersButton from './Button';
import styles from './styles.module.scss';

export default function OrderByProviders() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <span className={styles.container__label}>{t('suplier_label')}</span>

      <OrderByProvidersButton />
    </div>
  );
}
